import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		defaultMessage: 'Bulk action in progress',
		id: 'bulk-operations-common.submit-status.flags.in-progress-flag.title',
		description: 'Bulk edit form submission in progress flag title',
	},
	description: {
		defaultMessage: 'Stay on this page until the bulk action is finished.',
		id: 'bulk-operations-common.submit-status.flags.in-progress-flag.description',
		description: 'Bulk edit form submission in progress flag description',
	},
});
